/* Звернення і колл-центр (/inquiries, docs/processes C3). Kept apart from uk.ts/en.ts to keep merges small. */
export const callcenterUk = {
  'nav.inquiries': 'Звернення',
  'perm.callcenter.work': 'Звернення: черга, картка клієнта, запис, тріаж, лист очікування, передача зміни (без грошей)',
  'perm.callcenter.manage': 'Звернення: SLA, скрипти, маршрутизація, прайс-калькулятор, прапорці «НЕ ПРИЙМАТИ»',
  'callcenter.title': 'Звернення',
  'callcenter.subtitle': 'Дзвінки, чати, запити із застосунку й бота, Instagram і сайт — одна черга з таймерами відповіді',
  'callcenter.new': 'Звернення',
  'callcenter.price': 'Калькулятор вартості',
  'callcenter.tab.queue': 'Черга',
  'callcenter.tab.shift': 'Зміна',
  'callcenter.tab.waitlist': 'Лист очікування',
  'callcenter.tab.flags': '«НЕ ПРИЙМАТИ»',
  'callcenter.tab.settings': 'SLA',
  'callcenter.min': '{n} хв',
  'callcenter.hours': '{n} год',
  'callcenter.days': '{n} дн',
  'callcenter.sla.left': 'відповісти за {left}',
  'callcenter.sla.late': 'без відповіді {left}',
  'callcenter.sla.met': 'відповідь вчасно',
  'callcenter.sla.missed': 'відповідь із запізненням',
  'callcenter.unknownCaller': 'Невідомий',
  'callcenter.number': 'Звернення №{n}',
  'callcenter.search': 'Номер, телефон, ім\'я, кличка',
  'callcenter.filter.open': 'Відкриті',
  'callcenter.filter.all': 'Усі',
  'callcenter.filter.closed': 'Закриті',
  'callcenter.filter.allChannels': 'Усі канали',
  'callcenter.filter.allTopics': 'Усі теми',
  'callcenter.filter.overdue': 'Без відповіді вчасно',
  'callcenter.filter.mine': 'Мої',
  'callcenter.filter.unassigned': 'Нічиї',
  'callcenter.col.number': '№',
  'callcenter.col.who': 'Хто',
  'callcenter.col.channel': 'Канал і тема',
  'callcenter.col.status': 'Статус',
  'callcenter.col.sla': 'Відповідь',
  'callcenter.col.owner': 'Відповідальний',
  'callcenter.nobody': 'Нікому не призначено',
  'callcenter.empty': 'Відкритих звернень немає',
  'callcenter.emptyHint': 'Пропущені дзвінки, запити із застосунку й бота та нові повідомлення в чатах з\'являються тут самі. Звернення з Instagram, сайту чи Viber внесіть кнопкою «Звернення».',
  'callcenter.carried': 'з попередньої зміни',
  'callcenter.doNotAdmit': 'НЕ ПРИЙМАТИ',
  'callcenter.urgent': 'Терміново',
  'callcenter.high': 'Важливо',
  'callcenter.triage.red': 'Червоний',
  'callcenter.triage.yellow': 'Жовтий',
  'callcenter.triage.green': 'Зелений',
  'callcenter.channel.call': 'Дзвінок',
  'callcenter.channel.bot': 'Telegram-бот',
  'callcenter.channel.app': 'Застосунок',
  'callcenter.channel.chat': 'Чат',
  'callcenter.channel.site': 'Сайт',
  'callcenter.channel.instagram': 'Instagram',
  'callcenter.channel.viber': 'Viber',
  'callcenter.channel.walk_in': 'У клініці',
  'callcenter.channel.other': 'Інше',
  'callcenter.topic.booking': 'Запис',
  'callcenter.topic.price': 'Ціна',
  'callcenter.topic.symptoms': 'Симптоми',
  'callcenter.topic.reschedule': 'Перенесення / скасування',
  'callcenter.topic.travel': 'Виїзд за кордон',
  'callcenter.topic.after_visit': 'Після прийому',
  'callcenter.topic.online': 'Онлайн-консультація',
  'callcenter.topic.complaint': 'Скарга',
  'callcenter.topic.partnership': 'Реклама / партнерство',
  'callcenter.topic.urgent': 'Ургент',
  'callcenter.topic.callback': 'Передзвонити',
  'callcenter.topic.other': 'Інше',
  'callcenter.status.new': 'Нове',
  'callcenter.status.in_progress': 'В роботі',
  'callcenter.status.booked': 'Записано',
  'callcenter.status.answered': 'Надано відповідь',
  'callcenter.status.refused': 'Відмова',
  'callcenter.status.lost': 'Втрачено',
  'callcenter.createTitle': 'Нове звернення',
  'callcenter.createHint': 'Для Instagram, сайту, Viber, клієнта в клініці чи дзвінка, прийнятого наживо. Клієнта знайдемо за телефоном.',
  'callcenter.channel': 'Канал',
  'callcenter.topic': 'Тема',
  'callcenter.phone': 'Телефон',
  'callcenter.contactName': 'Ім\'я',
  'callcenter.externalRef': 'Нік / номер заявки',
  'callcenter.branch': 'Філія',
  'callcenter.anyBranch': 'Не вказано',
  'callcenter.summary': 'Що хоче клієнт',
  'callcenter.takeNow': 'Беру в роботу одразу',
  'callcenter.create': 'Зберегти',
  'callcenter.created': 'Звернення №{n} зареєстровано',
  'callcenter.detail': 'Звернення',
  'callcenter.take': 'Беру',
  'callcenter.triage': 'Тріаж',
  'callcenter.book': 'Записати',
  'callcenter.toWaitlist': 'У лист очікування',
  'callcenter.escalate': 'Передати в інциденти',
  'callcenter.close': 'Закрити',
  'callcenter.reopen': 'Повернути в роботу',
  'callcenter.note': 'Нотатка',
  'callcenter.notePlaceholder': 'Що сказали клієнту, що домовились',
  'callcenter.noteResponse': 'Клієнт отримав відповідь',
  'callcenter.addNote': 'Додати',
  'callcenter.timeline': 'Історія',
  'callcenter.owner': 'Відповідальний',
  'callcenter.slaNorm': 'Норма відповіді',
  'callcenter.incident': 'Інцидент №{n}',
  'callcenter.task': 'Задача «записати в Enote»: {status}',
  'callcenter.closeReason': 'Результат',
  'callcenter.linkedCall': 'Дзвінок',
  'callcenter.messages': 'Повідомлення',
  'callcenter.request': 'Запит із застосунку / бота',
  'callcenter.event.created': 'Створено',
  'callcenter.event.taken': 'Взято в роботу',
  'callcenter.event.assigned': 'Передано',
  'callcenter.event.updated': 'Змінено',
  'callcenter.event.note': 'Нотатка',
  'callcenter.event.status': 'Закрито',
  'callcenter.event.reopened': 'Повернуто в роботу',
  'callcenter.event.triage': 'Тріаж',
  'callcenter.event.booking': 'Запис',
  'callcenter.event.task': 'Задача',
  'callcenter.event.incident': 'Інцидент',
  'callcenter.event.handover': 'Передача зміни',
  'callcenter.event.waitlist': 'Лист очікування',
  'callcenter.event.sla': 'SLA',
  'callcenter.event.auto': 'Автоматично',
  'callcenter.closeTitle': 'Закрити звернення',
  'callcenter.outcome': 'Результат',
  'callcenter.reason': 'Причина / коментар',
  'callcenter.reasonRequired': 'Для відмови й втраченого звернення вкажіть причину',
  'callcenter.confirm': 'Підтвердити',
  'callcenter.escalateTitle': 'Передати в інциденти',
  'callcenter.escalateHint': 'Скарга, конфлікт чи «лікар не передзвонив» стане інцидентом з таймерами й ескалацією до керуючої.',
  'callcenter.incidentType': 'Тип',
  'callcenter.escalation.complaint': 'Скарга клієнта',
  'callcenter.escalation.conflict': 'Конфліктна ситуація',
  'callcenter.escalation.doctor_callback': 'Лікар не передзвонив / питання до лікаря',
  'callcenter.escalation.rabies_suspect': 'Підозра на сказ',
  'callcenter.escalation.other': 'Інше',
  'callcenter.escalateClose': 'Закрити звернення (передано в інциденти)',
  'callcenter.escalated': 'Інцидент створено',
  'callcenter.triageTitle': 'Телефонний тріаж',
  'callcenter.triageHint': 'Позначте, що з переліченого є. Червоний — клієнт їде без запису, лікарі ВРІТ отримають сповіщення.',
  'callcenter.triageNote': 'Симптоми, дихання, кровотеча, коли будуть',
  'callcenter.raiseCode': 'Оголосити «Код червоний» (пацієнт уже в клініці)',
  'callcenter.room': 'Де потрібна допомога',
  'callcenter.triageSave': 'Зберегти тріаж',
  'callcenter.triageResult': 'Тріаж: {level}',
  'callcenter.card': 'Картка клієнта',
  'callcenter.card.noMatch': 'Клієнта з цим номером немає в Enote — зберіть ПІБ, вид, породу, вік і стать тварини.',
  'callcenter.card.matches': 'З цим номером кілька клієнтів — оберіть:',
  'callcenter.card.choose': 'Це він',
  'callcenter.card.pets': 'Тварини',
  'callcenter.card.upcoming': 'Майбутні записи',
  'callcenter.card.past': 'Останні візити',
  'callcenter.card.calls': 'Останні дзвінки',
  'callcenter.card.openInquiries': 'Інші відкриті звернення',
  'callcenter.card.waitlist': 'У листі очікування',
  'callcenter.card.debt': 'Борг: {sum}',
  'callcenter.card.noDebt': 'Боргу немає',
  'callcenter.card.none': 'Немає',
  'callcenter.card.blacklist': 'Enote: чорний список',
  'callcenter.card.vip': 'VIP',
  'callcenter.card.risk': 'Ризик',
  'callcenter.card.years': '{n} р.',
  'callcenter.card.setFlag': '«НЕ ПРИЙМАТИ»',
  'callcenter.flagTitle': 'Позначка «НЕ ПРИЙМАТИ»',
  'callcenter.flagHint': 'Рішення керуючої або головного лікаря. Причину побачать оператори при кожному записі.',
  'callcenter.flagKind': 'Позначка',
  'callcenter.flag.do_not_admit': 'НЕ ПРИЙМАТИ',
  'callcenter.flag.risk': 'Ризик',
  'callcenter.flag.vip': 'VIP',
  'callcenter.flagSaved': 'Позначку збережено',
  'callcenter.flagClear': 'Зняти',
  'callcenter.flagClearTitle': 'Зняти позначку',
  'callcenter.flags.empty': 'Позначок немає',
  'callcenter.flags.emptyHint': 'Керівник ставить «НЕ ПРИЙМАТИ» з картки клієнта у зверненні. Позначка видна в черзі й блокує запис без погодження.',
  'callcenter.flags.client': 'Клієнт',
  'callcenter.flags.reason': 'Причина',
  'callcenter.flags.setBy': 'Хто і коли',
  'callcenter.flags.cleared': 'Знято {when}',
  'callcenter.flags.showAll': 'Показати зняті',
  'callcenter.wizard.title': 'Запис',
  'callcenter.wizard.step.script': 'Скрипт',
  'callcenter.wizard.step.doctor': 'Лікар і час',
  'callcenter.wizard.step.price': 'Вартість',
  'callcenter.wizard.step.confirm': 'Підтвердження',
  'callcenter.wizard.script': 'Тип звернення / візиту',
  'callcenter.wizard.pet': 'Тварина',
  'callcenter.wizard.noPet': 'Не обрано',
  'callcenter.wizard.questions': 'Запитати',
  'callcenter.wizard.preparation': 'Підготовка',
  'callcenter.wizard.rules': 'Правила',
  'callcenter.wizard.ageRules': 'За віком тварини',
  'callcenter.wizard.symptoms': 'Скарга (словами клієнта)',
  'callcenter.wizard.day': 'День',
  'callcenter.wizard.department': 'Філія Enote',
  'callcenter.wizard.anyDepartment': 'Будь-яка',
  'callcenter.wizard.visitKind': 'Вид прийому',
  'callcenter.wizard.anyKind': 'Не вказано',
  'callcenter.wizard.suggested': 'Пропонуємо: {title}',
  'callcenter.wizard.markers': 'за ознаками: {list}',
  'callcenter.wizard.fallback': 'Вузького спеціаліста не знайдено або ніхто не приймає — запис до терапевта з найменшим завантаженням.',
  'callcenter.wizard.load': 'записів: {n}',
  'callcenter.wizard.notAccepting': 'тимчасово не приймає',
  'callcenter.wizard.slots': 'Вільний час',
  'callcenter.wizard.noSlots': 'Вільних слотів у цей день немає',
  'callcenter.wizard.manualTime': 'Дата й час запису',
  'callcenter.wizard.noWriteback': 'Запис в Enote з Bridge вимкнено: після підтвердження з\'явиться задача «Записати в Enote», звернення закриється, коли запис з\'явиться в Enote.',
  'callcenter.wizard.noDoctors': 'Лікарів не знайдено — налаштуйте «лікар → спеціалізації» або оберіть інший день.',
  'callcenter.wizard.noPriceGroup': 'Для цього скрипту прайс не налаштовано — скористайтесь калькулятором вартості.',
  'callcenter.wizard.readBack': 'Проговоріть клієнту',
  'callcenter.wizard.readBackHint': 'Позначте кожен пункт — без цього запис не збережеться.',
  'callcenter.wizard.comment': 'Коментар для лікаря',
  'callcenter.wizard.override': 'Хто погодив запис («НЕ ПРИЙМАТИ»)',
  'callcenter.wizard.overrideHint': 'Клієнт з позначкою «НЕ ПРИЙМАТИ»: {reason}. Запис — лише після погодження з керівником.',
  'callcenter.wizard.next': 'Далі',
  'callcenter.wizard.back': 'Назад',
  'callcenter.wizard.submit': 'Записати',
  'callcenter.wizard.summary': '{doctor}, {when}',
  'callcenter.wizard.booked': 'Записано в Enote',
  'callcenter.wizard.task': 'Створено задачу «Записати в Enote»',
  'callcenter.calc.title': 'Калькулятор вартості',
  'callcenter.calc.hint': 'Ціни з прайсу Enote (завжди актуальні). Показуємо лише публічні позиції.',
  'callcenter.calc.group': 'Послуга',
  'callcenter.calc.chooseGroup': 'Оберіть послугу',
  'callcenter.calc.species': 'Вид',
  'callcenter.calc.cat': 'Кіт / кішка',
  'callcenter.calc.dog': 'Собака',
  'callcenter.calc.sex': 'Стать',
  'callcenter.calc.male': 'Самець',
  'callcenter.calc.female': 'Самка',
  'callcenter.calc.weight': 'Вага, кг',
  'callcenter.calc.night': 'Нічний тариф',
  'callcenter.calc.total': 'Разом: {sum}',
  'callcenter.calc.missing': 'уточнимо',
  'callcenter.calc.none': 'Під ці параметри позицій немає — вкажіть вид, стать і вагу.',
  'callcenter.calc.copy': 'Копіювати для месенджера',
  'callcenter.wl.addTitle': 'У лист очікування',
  'callcenter.wl.addHint': 'Коли звільниться час у лікаря чи відкриється графік, оператори отримають сповіщення.',
  'callcenter.wl.service': 'Що записати',
  'callcenter.wl.specialisation': 'Спеціалізація',
  'callcenter.wl.anySpec': 'Будь-яка',
  'callcenter.wl.from': 'Бажано з',
  'callcenter.wl.to': 'по',
  'callcenter.wl.timePref': 'Бажаний час',
  'callcenter.wl.timePrefHint': 'Напр. «після 17:00», «вихідні»',
  'callcenter.wl.note': 'Коментар',
  'callcenter.wl.added': 'Додано в лист очікування',
  'callcenter.wl.empty': 'Лист очікування порожній',
  'callcenter.wl.emptyHint': 'Коли потрібного часу немає, додайте клієнта зі звернення кнопкою «У лист очікування».',
  'callcenter.wl.slot': 'Є час',
  'callcenter.wl.expired': 'Минув період',
  'callcenter.wl.offered': 'Запропоновано',
  'callcenter.wl.booked': 'Записано',
  'callcenter.wl.cancel': 'Прибрати',
  'callcenter.wl.status.waiting': 'Чекає',
  'callcenter.wl.status.offered': 'Запропоновано',
  'callcenter.wl.status.booked': 'Записано',
  'callcenter.wl.status.cancelled': 'Прибрано',
  'callcenter.wl.col.who': 'Клієнт',
  'callcenter.wl.col.what': 'Що',
  'callcenter.wl.col.when': 'Коли',
  'callcenter.wl.col.status': 'Статус',
  'callcenter.shift.handover': 'Передати зміну',
  'callcenter.shift.handoverTitle': 'Передача зміни',
  'callcenter.shift.handoverHint': 'Ваші відкриті звернення й нічиї перейдуть наступній зміні; вона отримає чекліст прийому зміни.',
  'callcenter.shift.to': 'Кому',
  'callcenter.shift.toRole': 'Усім операторам колл-центру',
  'callcenter.shift.note': 'Що важливо знати',
  'callcenter.shift.done': 'Зміну передано: відкритих звернень — {n}',
  'callcenter.shift.accept': 'Прийняти зміну',
  'callcenter.shift.accepted': 'Прийнято: {name}',
  'callcenter.shift.pending': 'Очікує прийому',
  'callcenter.shift.handovers': 'Передачі змін',
  'callcenter.shift.noHandovers': 'Передач за останні 2 доби немає',
  'callcenter.shift.from': '{from} → {to}',
  'callcenter.shift.openCount': 'відкритих: {n}',
  'callcenter.shift.checklist': 'Чекліст',
  'callcenter.shift.start': 'Початок зміни',
  'callcenter.shift.startDone': 'Чекліст «Початок зміни» виконано',
  'callcenter.shift.startOpen': 'Чекліст «Початок зміни» чекає',
  'callcenter.shift.startNone': 'Чекліста «Початок зміни» на сьогодні немає (розклад у «Шаблони»)',
  'callcenter.shift.carried': 'Відкриті з попередніх змін',
  'callcenter.shift.missed': 'Пропущені дзвінки (вчора й сьогодні)',
  'callcenter.shift.calledBack': 'передзвонили',
  'callcenter.shift.notCalledBack': 'не передзвонили',
  'callcenter.shift.unanswered': 'Повідомлення без відповіді',
  'callcenter.shift.slots': 'Лист очікування: знайдено вільний час — {n}',
  'callcenter.shift.nothing': 'Нічого',
  'callcenter.sla.title': 'Норми відповіді',
  'callcenter.sla.hint': 'Час першої відповіді за каналом і темою. «Будь-який» — для решти. У робочі години — рахується лише з {from} до {to}.',
  'callcenter.sla.any': 'Будь-який',
  'callcenter.sla.minutes': 'Хвилин',
  'callcenter.sla.business': 'У робочі години',
  'callcenter.sla.toConfirm': 'Потребує підтвердження',
  'callcenter.sla.confirmed': 'Значення підтверджено власником',
  'callcenter.sla.saved': 'Збережено',
  'callcenter.sla.add': 'Додати норму',
  'today.inquiries': 'Звернення',
  'today.noInquiries': 'Усі звернення опрацьовано',
} as const

export const callcenterEn: { [K in keyof typeof callcenterUk]?: string } = {
  'nav.inquiries': 'Inquiries',
  'perm.callcenter.work': 'Inquiries: queue, caller card, booking, triage, waiting list, shift hand-over (no money)',
  'perm.callcenter.manage': 'Inquiries: SLAs, scripts, routing, price calculator, do-not-admit flags',
  'callcenter.title': 'Inquiries',
  'callcenter.subtitle': 'Calls, chats, app and bot requests, Instagram and the website — one queue with response timers',
  'callcenter.new': 'Inquiry',
  'callcenter.price': 'Price calculator',
  'callcenter.tab.queue': 'Queue',
  'callcenter.tab.shift': 'Shift',
  'callcenter.tab.waitlist': 'Waiting list',
  'callcenter.tab.flags': 'Do-not-admit',
  'callcenter.tab.settings': 'SLA',
  'callcenter.min': '{n} min',
  'callcenter.hours': '{n} h',
  'callcenter.days': '{n} d',
  'callcenter.sla.left': 'answer within {left}',
  'callcenter.sla.late': 'unanswered for {left}',
  'callcenter.sla.met': 'answered in time',
  'callcenter.sla.missed': 'answered late',
  'callcenter.unknownCaller': 'Unknown',
  'callcenter.number': 'Inquiry #{n}',
  'callcenter.search': 'Number, phone, name, pet',
  'callcenter.filter.open': 'Open',
  'callcenter.filter.all': 'All',
  'callcenter.filter.closed': 'Closed',
  'callcenter.filter.allChannels': 'All channels',
  'callcenter.filter.allTopics': 'All topics',
  'callcenter.filter.overdue': 'Not answered in time',
  'callcenter.filter.mine': 'Mine',
  'callcenter.filter.unassigned': 'Unassigned',
  'callcenter.col.who': 'Who',
  'callcenter.col.channel': 'Channel and topic',
  'callcenter.col.status': 'Status',
  'callcenter.col.sla': 'Response',
  'callcenter.col.owner': 'Owner',
  'callcenter.nobody': 'Unassigned',
  'callcenter.empty': 'No open inquiries',
  'callcenter.emptyHint': 'Missed calls, app and bot requests and new chat messages appear here by themselves. Enter Instagram, website or Viber requests with «Inquiry».',
  'callcenter.carried': 'from an earlier shift',
  'callcenter.doNotAdmit': 'DO NOT ADMIT',
  'callcenter.urgent': 'Urgent',
  'callcenter.high': 'Important',
  'callcenter.triage.red': 'Red',
  'callcenter.triage.yellow': 'Yellow',
  'callcenter.triage.green': 'Green',
  'callcenter.channel.call': 'Call',
  'callcenter.channel.bot': 'Telegram bot',
  'callcenter.channel.app': 'App',
  'callcenter.channel.chat': 'Chat',
  'callcenter.channel.site': 'Website',
  'callcenter.channel.walk_in': 'At the clinic',
  'callcenter.channel.other': 'Other',
  'callcenter.topic.booking': 'Booking',
  'callcenter.topic.price': 'Price',
  'callcenter.topic.symptoms': 'Symptoms',
  'callcenter.topic.reschedule': 'Reschedule / cancel',
  'callcenter.topic.travel': 'Travel abroad',
  'callcenter.topic.after_visit': 'After the visit',
  'callcenter.topic.online': 'Online consultation',
  'callcenter.topic.complaint': 'Complaint',
  'callcenter.topic.partnership': 'Advertising / partnership',
  'callcenter.topic.urgent': 'Urgent',
  'callcenter.topic.callback': 'Call back',
  'callcenter.topic.other': 'Other',
  'callcenter.status.new': 'New',
  'callcenter.status.in_progress': 'In progress',
  'callcenter.status.booked': 'Booked',
  'callcenter.status.answered': 'Answered',
  'callcenter.status.refused': 'Refused',
  'callcenter.status.lost': 'Lost',
  'callcenter.createTitle': 'New inquiry',
  'callcenter.createHint': 'For Instagram, the website, Viber, a client at the desk or a call taken live. The client is found by phone.',
  'callcenter.channel': 'Channel',
  'callcenter.topic': 'Topic',
  'callcenter.phone': 'Phone',
  'callcenter.contactName': 'Name',
  'callcenter.externalRef': 'Nick / request number',
  'callcenter.branch': 'Branch',
  'callcenter.anyBranch': 'Not set',
  'callcenter.summary': 'What the client wants',
  'callcenter.takeNow': 'Take it now',
  'callcenter.create': 'Save',
  'callcenter.created': 'Inquiry #{n} registered',
  'callcenter.detail': 'Inquiry',
  'callcenter.take': 'Take',
  'callcenter.triage': 'Triage',
  'callcenter.book': 'Book',
  'callcenter.toWaitlist': 'To waiting list',
  'callcenter.escalate': 'Pass to incidents',
  'callcenter.close': 'Close',
  'callcenter.reopen': 'Reopen',
  'callcenter.note': 'Note',
  'callcenter.notePlaceholder': 'What the client was told, what was agreed',
  'callcenter.noteResponse': 'The client got an answer',
  'callcenter.addNote': 'Add',
  'callcenter.timeline': 'History',
  'callcenter.owner': 'Owner',
  'callcenter.slaNorm': 'Response norm',
  'callcenter.incident': 'Incident #{n}',
  'callcenter.task': '«Book in Enote» task: {status}',
  'callcenter.closeReason': 'Outcome',
  'callcenter.linkedCall': 'Call',
  'callcenter.messages': 'Messages',
  'callcenter.request': 'App / bot request',
  'callcenter.event.created': 'Created',
  'callcenter.event.taken': 'Taken',
  'callcenter.event.assigned': 'Assigned',
  'callcenter.event.updated': 'Changed',
  'callcenter.event.note': 'Note',
  'callcenter.event.status': 'Closed',
  'callcenter.event.reopened': 'Reopened',
  'callcenter.event.triage': 'Triage',
  'callcenter.event.booking': 'Booking',
  'callcenter.event.task': 'Task',
  'callcenter.event.incident': 'Incident',
  'callcenter.event.handover': 'Shift hand-over',
  'callcenter.event.waitlist': 'Waiting list',
  'callcenter.event.auto': 'Automatic',
  'callcenter.closeTitle': 'Close inquiry',
  'callcenter.outcome': 'Outcome',
  'callcenter.reason': 'Reason / comment',
  'callcenter.reasonRequired': 'Give the reason of a refusal or a lost inquiry',
  'callcenter.confirm': 'Confirm',
  'callcenter.escalateTitle': 'Pass to incidents',
  'callcenter.escalateHint': 'A complaint, a conflict or «the doctor did not call back» becomes an incident with timers and escalation to the manager.',
  'callcenter.incidentType': 'Type',
  'callcenter.escalation.complaint': 'Client complaint',
  'callcenter.escalation.conflict': 'Conflict',
  'callcenter.escalation.doctor_callback': 'Doctor did not call back / question to the doctor',
  'callcenter.escalation.rabies_suspect': 'Rabies suspicion',
  'callcenter.escalation.other': 'Other',
  'callcenter.escalateClose': 'Close the inquiry (passed to incidents)',
  'callcenter.escalated': 'Incident created',
  'callcenter.triageTitle': 'Phone triage',
  'callcenter.triageHint': 'Tick what applies. Red — the client comes without an appointment and the ICU doctors are alerted.',
  'callcenter.triageNote': 'Symptoms, breathing, bleeding, arrival time',
  'callcenter.raiseCode': 'Announce «Code red» (the patient is already here)',
  'callcenter.room': 'Where help is needed',
  'callcenter.triageSave': 'Save triage',
  'callcenter.triageResult': 'Triage: {level}',
  'callcenter.card': 'Caller card',
  'callcenter.card.noMatch': 'No client with this number in Enote — collect the name, species, breed, age and sex of the pet.',
  'callcenter.card.matches': 'Several clients have this number — choose:',
  'callcenter.card.choose': 'This one',
  'callcenter.card.pets': 'Pets',
  'callcenter.card.upcoming': 'Upcoming appointments',
  'callcenter.card.past': 'Last visits',
  'callcenter.card.calls': 'Last calls',
  'callcenter.card.openInquiries': 'Other open inquiries',
  'callcenter.card.waitlist': 'On the waiting list',
  'callcenter.card.debt': 'Debt: {sum}',
  'callcenter.card.noDebt': 'No debt',
  'callcenter.card.none': 'None',
  'callcenter.card.blacklist': 'Enote: blacklist',
  'callcenter.card.risk': 'Risk',
  'callcenter.card.years': '{n} y',
  'callcenter.card.setFlag': 'Do not admit',
  'callcenter.flagTitle': '«Do not admit» flag',
  'callcenter.flagHint': 'Decision of the manager or the chief doctor. Operators see the reason on every booking.',
  'callcenter.flagKind': 'Flag',
  'callcenter.flag.do_not_admit': 'DO NOT ADMIT',
  'callcenter.flag.risk': 'Risk',
  'callcenter.flagSaved': 'Flag saved',
  'callcenter.flagClear': 'Clear',
  'callcenter.flagClearTitle': 'Clear flag',
  'callcenter.flags.empty': 'No flags',
  'callcenter.flags.emptyHint': 'A manager sets «do not admit» from the caller card of an inquiry. The flag shows in the queue and blocks booking without approval.',
  'callcenter.flags.client': 'Client',
  'callcenter.flags.reason': 'Reason',
  'callcenter.flags.setBy': 'By and when',
  'callcenter.flags.cleared': 'Cleared {when}',
  'callcenter.flags.showAll': 'Show cleared',
  'callcenter.wizard.title': 'Booking',
  'callcenter.wizard.step.script': 'Script',
  'callcenter.wizard.step.doctor': 'Doctor and time',
  'callcenter.wizard.step.price': 'Price',
  'callcenter.wizard.step.confirm': 'Confirmation',
  'callcenter.wizard.script': 'Inquiry / visit type',
  'callcenter.wizard.pet': 'Pet',
  'callcenter.wizard.noPet': 'Not chosen',
  'callcenter.wizard.questions': 'Ask',
  'callcenter.wizard.preparation': 'Preparation',
  'callcenter.wizard.rules': 'Rules',
  'callcenter.wizard.ageRules': 'By the pet\'s age',
  'callcenter.wizard.symptoms': 'Complaint (client\'s words)',
  'callcenter.wizard.day': 'Day',
  'callcenter.wizard.department': 'Enote branch',
  'callcenter.wizard.anyDepartment': 'Any',
  'callcenter.wizard.visitKind': 'Visit kind',
  'callcenter.wizard.anyKind': 'Not set',
  'callcenter.wizard.suggested': 'Suggested: {title}',
  'callcenter.wizard.markers': 'by: {list}',
  'callcenter.wizard.fallback': 'No specialist found or nobody accepts — book the least loaded therapist.',
  'callcenter.wizard.load': 'appointments: {n}',
  'callcenter.wizard.notAccepting': 'temporarily not accepting',
  'callcenter.wizard.slots': 'Free time',
  'callcenter.wizard.noSlots': 'No free slots that day',
  'callcenter.wizard.manualTime': 'Date and time',
  'callcenter.wizard.noWriteback': 'Booking in Enote from Bridge is off: confirming creates a «Book in Enote» task; the inquiry closes when the appointment appears in Enote.',
  'callcenter.wizard.noDoctors': 'No doctors found — set up «doctor → specialisations» or pick another day.',
  'callcenter.wizard.noPriceGroup': 'No price list for this script — use the price calculator.',
  'callcenter.wizard.readBack': 'Read back to the client',
  'callcenter.wizard.readBackHint': 'Tick every item — the booking is not saved without it.',
  'callcenter.wizard.comment': 'Comment for the doctor',
  'callcenter.wizard.override': 'Who approved the booking (do not admit)',
  'callcenter.wizard.overrideHint': 'The client is flagged «do not admit»: {reason}. Book only after the manager approves.',
  'callcenter.wizard.next': 'Next',
  'callcenter.wizard.back': 'Back',
  'callcenter.wizard.submit': 'Book',
  'callcenter.wizard.booked': 'Booked in Enote',
  'callcenter.wizard.task': '«Book in Enote» task created',
  'callcenter.calc.title': 'Price calculator',
  'callcenter.calc.hint': 'Prices from the Enote price list (always current). Public items only.',
  'callcenter.calc.group': 'Service',
  'callcenter.calc.chooseGroup': 'Choose a service',
  'callcenter.calc.species': 'Species',
  'callcenter.calc.cat': 'Cat',
  'callcenter.calc.dog': 'Dog',
  'callcenter.calc.sex': 'Sex',
  'callcenter.calc.male': 'Male',
  'callcenter.calc.female': 'Female',
  'callcenter.calc.weight': 'Weight, kg',
  'callcenter.calc.night': 'Night tariff',
  'callcenter.calc.total': 'Total: {sum}',
  'callcenter.calc.missing': 'to confirm',
  'callcenter.calc.none': 'No items for these parameters — give species, sex and weight.',
  'callcenter.calc.copy': 'Copy for a messenger',
  'callcenter.wl.addTitle': 'To the waiting list',
  'callcenter.wl.addHint': 'Operators are notified when the doctor has free time or the schedule opens.',
  'callcenter.wl.service': 'What to book',
  'callcenter.wl.specialisation': 'Specialisation',
  'callcenter.wl.anySpec': 'Any',
  'callcenter.wl.from': 'Wanted from',
  'callcenter.wl.to': 'to',
  'callcenter.wl.timePref': 'Preferred time',
  'callcenter.wl.timePrefHint': 'E.g. «after 17:00», «weekends»',
  'callcenter.wl.note': 'Comment',
  'callcenter.wl.added': 'Added to the waiting list',
  'callcenter.wl.empty': 'The waiting list is empty',
  'callcenter.wl.emptyHint': 'When there is no suitable time, add the client from the inquiry with «To waiting list».',
  'callcenter.wl.slot': 'Free time',
  'callcenter.wl.expired': 'Period passed',
  'callcenter.wl.offered': 'Offered',
  'callcenter.wl.booked': 'Booked',
  'callcenter.wl.cancel': 'Remove',
  'callcenter.wl.status.waiting': 'Waiting',
  'callcenter.wl.status.offered': 'Offered',
  'callcenter.wl.status.booked': 'Booked',
  'callcenter.wl.status.cancelled': 'Removed',
  'callcenter.wl.col.who': 'Client',
  'callcenter.wl.col.what': 'What',
  'callcenter.wl.col.when': 'When',
  'callcenter.wl.col.status': 'Status',
  'callcenter.shift.handover': 'Hand over the shift',
  'callcenter.shift.handoverTitle': 'Shift hand-over',
  'callcenter.shift.handoverHint': 'Your open inquiries and the unassigned ones go to the next shift; it gets the shift acceptance checklist.',
  'callcenter.shift.to': 'To',
  'callcenter.shift.toRole': 'All call-centre operators',
  'callcenter.shift.note': 'What to know',
  'callcenter.shift.done': 'Shift handed over: {n} open inquiries',
  'callcenter.shift.accept': 'Accept the shift',
  'callcenter.shift.accepted': 'Accepted: {name}',
  'callcenter.shift.pending': 'Waiting for acceptance',
  'callcenter.shift.handovers': 'Shift hand-overs',
  'callcenter.shift.noHandovers': 'No hand-overs in the last 2 days',
  'callcenter.shift.openCount': 'open: {n}',
  'callcenter.shift.checklist': 'Checklist',
  'callcenter.shift.start': 'Start of shift',
  'callcenter.shift.startDone': '«Start of shift» checklist done',
  'callcenter.shift.startOpen': '«Start of shift» checklist is waiting',
  'callcenter.shift.startNone': 'No «Start of shift» checklist today (schedule in «Templates»)',
  'callcenter.shift.carried': 'Open from earlier shifts',
  'callcenter.shift.missed': 'Missed calls (yesterday and today)',
  'callcenter.shift.calledBack': 'called back',
  'callcenter.shift.notCalledBack': 'not called back',
  'callcenter.shift.unanswered': 'Unanswered messages',
  'callcenter.shift.slots': 'Waiting list: free time found — {n}',
  'callcenter.shift.nothing': 'Nothing',
  'callcenter.sla.title': 'Response norms',
  'callcenter.sla.hint': 'First response time per channel and topic. «Any» covers the rest. Business hours count only from {from} to {to}.',
  'callcenter.sla.any': 'Any',
  'callcenter.sla.minutes': 'Minutes',
  'callcenter.sla.business': 'Business hours',
  'callcenter.sla.toConfirm': 'To confirm',
  'callcenter.sla.confirmed': 'Confirmed by the owner',
  'callcenter.sla.saved': 'Saved',
  'callcenter.sla.add': 'Add norm',
  'today.inquiries': 'Inquiries',
  'today.noInquiries': 'All inquiries handled',
}
